import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "amem" }
const _hoisted_2 = {
  class: "amem__kpis",
  "data-tour": "admin-members-kpis"
}
const _hoisted_3 = { class: "sui-card amem__kpi" }
const _hoisted_4 = { class: "amem__kpi-value" }
const _hoisted_5 = { class: "sui-card amem__kpi" }
const _hoisted_6 = { class: "amem__kpi-value" }
const _hoisted_7 = {
  class: "sui-card sui-card--flush",
  "data-tour": "admin-members-list"
}
const _hoisted_8 = {
  class: "sui-toolbar",
  "data-tour": "admin-members-toolbar"
}
const _hoisted_9 = { class: "sui-search" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "amem__error"
}
const _hoisted_13 = {
  key: 1,
  class: "sui-table-wrap"
}
const _hoisted_14 = { class: "sui-table" }
const _hoisted_15 = { class: "amem__org" }
const _hoisted_16 = { class: "sui-table__strong" }
const _hoisted_17 = {
  key: 0,
  class: "amem__chip"
}
const _hoisted_18 = { class: "sui-table__sub" }
const _hoisted_19 = { class: "sui-table__sub" }
const _hoisted_20 = {
  key: 0,
  class: "sui-table__strong"
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 2,
  class: "sui-table__sub"
}
const _hoisted_23 = {
  key: 2,
  class: "sui-empty"
}

import { computed, onMounted, ref } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import { fetchAdminMembers, type AdminMemberRow } from '@/api/admin'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminMembersPage',
  setup(__props) {

const members = ref<AdminMemberRow[]>([])
const keyword = ref('')
const loading = ref(false)
const errorMessage = ref('')

function formatDate(value?: string | null) {
  const raw = String(value || '').trim()
  if (!raw) return '-'
  return raw.slice(0, 10)
}

const orderedCount = computed(
  () => members.value.filter((row) => (Number(row.orderCount) || 0) > 0).length,
)

async function load() {
  loading.value = true
  errorMessage.value = ''
  try {
    members.value = await fetchAdminMembers(keyword.value)
  } catch (error) {
    members.value = []
    errorMessage.value = error instanceof Error ? error.message : '고객 목록을 불러오지 못했습니다.'
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  void load()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("article", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "amem__kpi-label" }, "고객", -1)),
        _createElementVNode("span", _hoisted_4, [
          _createTextVNode(_toDisplayString(members.value.length), 1),
          _cache[1] || (_cache[1] = _createElementVNode("em", null, "곳", -1))
        ])
      ]),
      _createElementVNode("article", _hoisted_5, [
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "amem__kpi-label" }, "주문한 곳", -1)),
        _createElementVNode("span", _hoisted_6, [
          _createTextVNode(_toDisplayString(orderedCount.value), 1),
          _cache[3] || (_cache[3] = _createElementVNode("em", null, "곳", -1))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("label", _hoisted_9, [
          _createVNode(AppIcon, {
            icon: "mdi-magnify",
            size: 17
          }),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
            type: "search",
            placeholder: "시설명 · 아이디 · 대표자 · 기관기호",
            onKeyup: _withKeys(load, ["enter"])
          }, null, 544), [
            [
              _vModelText,
              keyword.value,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "sui-btn",
          disabled: loading.value,
          onClick: load
        }, [
          _createVNode(AppIcon, {
            icon: "mdi-magnify",
            size: 16
          }),
          _cache[5] || (_cache[5] = _createTextVNode(" 검색 ", -1))
        ], 8, _hoisted_10),
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "sui-toolbar__spacer" }, null, -1)),
        _createElementVNode("button", {
          type: "button",
          class: "sui-btn",
          disabled: loading.value,
          onClick: load
        }, [
          _createVNode(AppIcon, {
            icon: "mdi-refresh",
            size: 16
          }),
          _cache[6] || (_cache[6] = _createTextVNode(" 새로고침 ", -1))
        ], 8, _hoisted_11)
      ]),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
            _createVNode(AppIcon, {
              icon: "mdi-alert-outline",
              size: 16
            }),
            _createTextVNode(" " + _toDisplayString(errorMessage.value), 1)
          ]))
        : _createCommentVNode("", true),
      (members.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("table", _hoisted_14, [
              _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "기관"),
                  _createElementVNode("th", null, "아이디"),
                  _createElementVNode("th", null, "대표 · 연락처"),
                  _createElementVNode("th", null, "가입일"),
                  _createElementVNode("th", null, "주문")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(members.value, (row) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: row.mCode
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(row.orgName), 1),
                        (row.signupSource === 'WEB')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, "쇼핑몰"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(row.longtermCode || '기관기호 없음'), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", null, _toDisplayString(row.userId || '-'), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", null, _toDisplayString(row.bossName || '-'), 1),
                      _createElementVNode("span", _hoisted_19, _toDisplayString(row.bossPhone || row.orgPhone || row.bossEmail || '-'), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", null, _toDisplayString(formatDate(row.joinedAt)), 1)
                    ]),
                    _createElementVNode("td", null, [
                      ((row.orderCount || 0) > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(row.orderCount) + "건 ", 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_21, "없음")),
                      (row.lastOrderedAt)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, " 최근 " + _toDisplayString(formatDate(row.lastOrderedAt)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createVNode(AppIcon, {
              icon: "mdi-account-multiple-outline",
              size: 32
            }),
            _createElementVNode("p", null, _toDisplayString(loading.value ? '불러오는 중입니다…' : '조건에 맞는 고객이 없습니다.'), 1)
          ]))
    ])
  ]))
}
}

})